import CommitmentDetails from './CommitmentDetails';

export default CommitmentDetails;
